import { Skeleton } from '@/components/ui/skeleton'

export default function TokenUsageAnalyticsSkeleton() {
  return (
    <div className="space-y-4 motion-reduce:[&_[data-slot=skeleton]]:animate-none" aria-hidden="true">
      <div className="space-y-2"><Skeleton className="h-6 w-40" /><Skeleton className="h-3 w-56 max-w-full" /></div>
      <Skeleton className="h-[220px] w-full rounded-xl" />
      <Skeleton className="h-[520px] w-full rounded-xl" />
    </div>
  )
}
